import clsx from "clsx";
import React from "react";
import "./settingsContainerNav.scss";

interface ISettingsContainerNavProps extends React.ComponentPropsWithoutRef<"div"> { }

export const SettingsContainerNav = (props: ISettingsContainerNavProps) => {
    return <div {...props} className={clsx("settings-container-nav", props.className)} />;
};
